import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DocumentUploadComponent } from './document-upload/document-upload.component';

export const documentRoutes: Routes = [
  {
    path: 'document',
    children: [
      {
        path: 'upload',
        component: DocumentUploadComponent
      }
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(documentRoutes)],
  exports: [RouterModule]
})
export class DocumentRoutingModule { }



// WEBPACK FOOTER //
// /opt/app/src/app/features/document/document-routing.module.ts